<template>
  <div class="card">
    <!-- Card content -->
    <div class="card-body">
      <!-- Title -->
      <div class="row">
        <div class="col-md-11">
          <h6 class="card-title">
           <a>{{ pergunta.ordemExibicao}} ) {{ pergunta.titulo }}</a>
            <span
              v-if="pergunta.obrigatoria"
              style="color: red; font-weigth: bold"
              >*</span
            >
          </h6>
        </div>
        <div class="col">
          <!-- <span class="badge badge-success" style="float:rigth"><i class="bi bi-check"></i></span> -->
        </div>
      </div>
      <h6>
        <small  class="text-muted">
          Exemplo.: 70,00 Kg
        </small>
      </h6>
      <!-- Text -->
      <p class="card-text" v-html="pergunta.descricao"></p>
      <div class="container2">
        <div class="row">
          <!--opcoes de resposta -->
          <div class="col-md-12">
          
            <div class="form-group">
              <label>
                    <input

                    blur="validarResposta"
                    @blur="onBlurInputHandler"
                    :required="pergunta.obrigatoria"
                    @input="maskPeso(resposta)"
                    placeholder="Quilos"
                    :min="pergunta.valorMinimoResposta"
                    :max="pergunta.valorMaximoResposta"
                    class="form-control input-sm"
                    type="text"
                    :id="'txtNumeroDecimal_' + pergunta.perguntaId"
                    name="txtNumeroDecimal"                
                    v-model="resposta"
                    maxlength="6"
                />               
              </label>
    
            </div>

            <ul v-if="temErro" class="alert alert-sm alert-danger">
              <li :key="index" v-for="(erro, index) in erros">
                {{ `- ${erro}` }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import repostaPerguntaMethodsMixin from "./ResponderPerguntaMixin";
export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: "comp-pergunta-peso",
  props: ["pergunta", "permitirResponder", "formulario"],
  data() {
    return {
      resposta: "",
      temErro: false,
      avisoErro: "",
      erros: []      
    };
  },
  computed: {
    botaoDesabilitado() {
      return this.resposta === "" || !this.permitirResponder;
    },
  },
  methods: {
      maskPeso(resposta){
   
        let novaResposta = resposta.replace(/[\D]/g, '') // substitui qualquer caracter que nao seja numero por nada
        let part1, part2 = '';

        if(novaResposta.length == 3){
            part1 = novaResposta.substr(0,2);
            part2 = novaResposta.substr(2);
            novaResposta = `${part1},${part2}`
        }
        else if(novaResposta.length == 4){
             part1 = novaResposta.substr(0,2);
             part2 = novaResposta.substr(2,2);
            novaResposta = `${part1},${part2}`
        }else if(novaResposta.length > 4){
            novaResposta =novaResposta.replace(/[\D]/g, '')
             part1 = novaResposta.substr(0,3);
             part2 = novaResposta.substring(3);
            novaResposta = `${part1},${part2}`
        }
         this.resposta = novaResposta;
      },
    onBlurInputHandler(e){
 
        this.validarResposta();       
        this.aplicarValidacaoPorValorMixin();
        
    },  
    async validarResposta() {
  
      this.erros = [];
      const pergunta = this.pergunta;
      const { perguntaId,sessao,sessaoFormularioPerguntaId } = this.pergunta;
      const opcaoResposta = {
        opcaoResposta: {
          opcaoRespostaId: null,
          perguntaId,
          sessaoFormularioPerguntaId,
          valor: this.resposta,
        },
        pergunta,
      };

      const deveInformarValorMinimo = (pergunta.valorMinimoResposta!=null && pergunta.valorMinimoResposta >= 0);
      const deveInformarValorMaximo =( pergunta.valorMaximoResposta !=null && pergunta.valorMaximoResposta >= 0);

      const valorMinimoResposta = Number(pergunta.valorMinimoResposta);
      const valorMaximoResposta = Number(pergunta.valorMaximoResposta);
      const valorResposta = Number(this.resposta.replace(/,/g,'.'));

      //remover o valor de resposta anterior
      this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);

      if (this.pergunta.obrigatoria && !this.resposta) {
        this.erros.push("Você deve responder esta pergunta.");
      }
      //validar se o valor esta dentro do minimo e máximo
      if (deveInformarValorMinimo) {
        if (valorResposta < valorMinimoResposta) {
          this.erros.push(
            `Você deve informar um valor mínimo para esta pergunta. (${valorMinimoResposta})`
          );
        }
      }

      if (deveInformarValorMaximo) {
        if (valorResposta > valorMaximoResposta) {
          this.erros.push(
            `Você informou um valor maior que o máximo permitido. (${valorMaximoResposta})`
          );
        }
      }

      // this.temErro = this.pergunta.obrigatoria && !this.resposta
      this.temErro = this.erros.length > 0;
      if (this.temErro) {
        this.avisoErro = "Você deve informar um número válido";
      } else {
        this.responderPerguntaMixin(opcaoResposta);
      }
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
ul {
  list-style: none;
}
ul li.alert {
}
</style>>

</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/RespostaTipoPeso.vue